export class Person {
  name: string;
  surname: string;
  birth: string;
  nationality: string;
  position: string;

  constructor(person?: AnswerPerson) {
    if (person == undefined) {
      this.name = "";
      this.surname = "";
      this.birth = "";
      this.nationality = "";
      this.position = "";
    } else {
      this.name = person.name;
      this.surname = person.surname;
      this.birth = person.birth;
      this.nationality = person.nationality;
      this.position = person.position;
    }
  }

  toAnswerModel(): AnswerPerson {
    return new AnswerPerson(this);
  }
}

export class AnswerPerson {
  name: string;
  surname: string;
  birth: string;
  nationality: string;
  position: string;

  constructor(person: Person) {
    this.name = person.name;
    this.surname = person.surname;
    this.birth = person.birth;
    this.nationality = person.nationality;
    this.position = person.position;
  }
}
